import React from 'react'

const Alert = () => (
    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm0-8.5a1 1 0 0 0-1 1V11a1 1 0 1 0 2 0V8.5a1 1 0 0 0-1-1Zm0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75Z" fill="#FFB400" fill-rule="evenodd"/></svg>
)

export default Alert